import { LayoutRecord } from "./LayoutRecord";

/**
 * The `layout_id` that `createEmptyLayout()` stamps on the placeholder layout a workspace starts
 * with when it opens without a saved one. No layout with this ID exists in the backend, so carrying
 * it marks a layout the user has not saved and consumers present it as nothing being selected:
 *
 * 1. The layout name renders as "No layout selected" rather than the placeholder's "Untitled layout".
 * 2. The `layout` URL search param, which otherwise holds the active layout's name, is deleted.
 * 3. "Save layout" opens the create-a-layout flow instead of overwriting a stored record.
 */
export const TEMPORARY_LAYOUT_ID = "initial-workspace-layout";

/**
 * True when `layout` is the unsaved placeholder rather than a record loaded from the backend. See
 * `TEMPORARY_LAYOUT_ID` for what callers do with the answer.
 */
export function isTemporaryLayout(layout: LayoutRecord): boolean {
  return layout.layout_id === TEMPORARY_LAYOUT_ID;
}
